import { render, staticRenderFns } from "./PcHome.vue?vue&type=template&id=690aefe4&scoped=true&"
var script = {}
import style0 from "./PcHome.vue?vue&type=style&index=0&id=690aefe4&scoped=true&lang=css&"
import style1 from "./PcHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690aefe4",
  null
  
)

export default component.exports